import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-long-left', 'ArrowLongLeft', [["path",{"d":"m6 8-4 4m0 0 4 4m-4-4h20","key":"svg-0"}]]);